import React from 'react';

const LinkIdTask = ({ linkToRef, idTask }) => (
  <a
    ref={linkToRef}
    rel="noopener noreferrer"
    href={`/pedidos/${idTask}/orcamentos`}
  >
    #
    {idTask}
  </a>
);

export default LinkIdTask;
